import React from "react";
import AboutImg1 from '../Img/1.png';
import AboutImg2 from '../Img/2.png';
import AboutImg3 from '../Img/3.png';
import { BadgeCheck, Clock4, Users } from "lucide-react";
import { useNavigate } from "react-router-dom";

const AboutMainSection = () => {
    const navigate = useNavigate()
    return (
        <section className="about-home-main-section">
            <div className="about-home-content-container">
                {/* Left: Images */}
                <div className="about-home-images-column">
                    <div className="about-home-image about-home-image-top">
                        <img src={AboutImg1} alt="About Top" />
                    </div>
                    <div className="about-home-image about-home-image-middle">
                        <img src={AboutImg2} alt="About Middle" />
                    </div>
                    <div className="about-home-image about-home-image-bottom">
                        <img src={AboutImg3} alt="About Bottom" />
                    </div>
                </div>

                <div className="about-home-text-column">
                    <h2 className="about-home-heading">Welcome to Radical Sports India</h2>
                    <p className="about-home-subheading">
                        Radical Sports India is a premier <strong>roller skating academy</strong> dedicated to nurturing talent across all age groups. We provide <strong>professional coaching</strong> in a safe, fun, and motivating environment.
                    </p>
                    <p className="about-home-subheading">
                        From beginners to aspiring champions, our certified trainers ensure <strong>structured training programs</strong>, fitness development, and regular assessments for holistic growth.
                    </p>

                    <ul className="about-home-features">
                        <li>
                            <BadgeCheck size={20} className="about-home-icon" />
                            Certified coaches and personalized training
                        </li>
                        <li>
                            <Users size={20} className="about-home-icon" />
                            5000+ skaters trained across India
                        </li>
                        <li>
                            <Clock4 size={20} className="about-home-icon" />
                            Flexible weekend & weekday batches
                        </li>
                    </ul>

                    <button className="about-home-button" onClick={() => navigate("/admission-form")}>Join the Academy</button>
                </div>

            </div>
        </section>
    );
};

export default AboutMainSection;
